import { Button, Flex, Tooltip, Typography } from 'antd'
import { Download, ExternalLink } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { DateTimeCell } from 'src/components/DateTimeCell'

import { formatFileSize, opensInline } from './attachments'
import type { ChatFileListItem } from './attachments'
import { ChatAttachmentIcon } from './ChatAttachmentIcon'
import { useStyles } from './styles'

const { Text } = Typography

type Props = {
  file: ChatFileListItem
  busy: boolean
  onOpen: (file: ChatFileListItem) => void
}

export const ChatFilesListRow = ({ file, busy, onOpen }: Props) => {
  const { styles } = useStyles()
  const { t } = useTranslation()
  const inline = opensInline(file.mimeType)
  const action = inline
    ? t('workspaceHome.attachments.open')
    : t('workspaceHome.attachments.download')
  const source =
    file.source === 'user'
      ? t('workspaceHome.attachments.fromYou')
      : t('workspaceHome.attachments.fromAgent')

  return (
    <li className={styles.filesListRow}>
      <Flex align="center" gap="small">
        <ChatAttachmentIcon
          filename={file.filename}
          mimeType={file.mimeType}
          size={16}
          className={styles.attachmentIcon}
        />
        <Flex vertical className={styles.filesListBody}>
          <Text ellipsis={{ tooltip: file.filename }}>{file.filename}</Text>
          <Text type="secondary" className={styles.filesListMeta}>
            {`${formatFileSize(file.sizeBytes)} · ${source} · `}
            <DateTimeCell value={file.createdAt} variant="relative" muted />
          </Text>
        </Flex>
        <Tooltip title={action}>
          <Button
            type="text"
            size="small"
            icon={
              inline ? (
                <ExternalLink size={14} strokeWidth={1.5} />
              ) : (
                <Download size={14} strokeWidth={1.5} />
              )
            }
            aria-label={action}
            disabled={busy}
            onClick={() => onOpen(file)}
          />
        </Tooltip>
      </Flex>
    </li>
  )
}
